<template>
    <div v-if="media.length > 0" class="screen-shot-container">
        <div class="show-area">
            <img
                v-if="media[imageIndex].type === 2"
                :src="media[imageIndex].poster"
                preview="99"
                @load="refreshPreview"
                @click="doClickLog('enlarge', imageIndex)"
            >
            <GameVideo
                v-else
                :poster="media[imageIndex].poster"
                :src="media[imageIndex].url"
                :index="imageIndex"
                :item="{}"
                :auto-play="imageIndex === 0 && $wifi"
            />
        </div>
        <div v-if="media.length>1" class="side-slip scroll-x"> 
            <div 
                v-for="(item, index) of media"
                :key="index"
                v-lazy:background-image="item.poster"
                :class="['side-slip-item', imageIndex === index ? 'item-focus' : '']"
                @click="changeImage(index)"
            >
            </div>
        </div>
    </div>
</template>

<script>
    import GameVideo from '../video/app-video-box'
    export default {
        components: {
            GameVideo
        },
        props: {
            media: {
                type: Array,
                required: true
            },
        },
        data() {
            return {
                imageIndex: 0
            }
        },
        mounted() {
            if (this.media.length > 0) {
                this.doDisplayLog(this.media[0], 0);
            }
        },
        methods: {
            changeImage(index) {
                this.imageIndex = index;
                this.doDisplayLog(this.media[index], index);
            },
            refreshPreview() {
                this.$previewRefresh();
            },
            doDisplayLog(item, index) {
                this.$logger.display({
                    value: 'preview',
                    ext: {
                        item: [
                            {
                                id: '',
                                ext: Object.assign({
                                    previewType: item.type === 1 ? 'video' : 'picture'
                                }, this.$root.extData),
                                pos: index + 1
                            }
                        ]
                    }
                });
            },
            doClickLog(type, index) {
                let content = {
                    value: 'preview',
                    ext: {
                        id: '',
                        ext: Object.assign({
                            clickType: type
                        }, this.$root.extData),
                        pos: index + 1
                    }
                }
                this.$logger.click(content);
            }
        }
    };
</script>

<style lang="scss">
    @import "~@/common/style/mixin/utils";
    $design-width: 1242;
    
    .screen-shot-container {
        .show-area {
            height: px2rem(699);
            img {
                width: 100%;
                height: 100%;
            }
            .gp-app-video {
                border-radius: 0;
            }
        }
        .side-slip {
            height: px2rem(134);
            display: flex;
            align-items: center;
            background-color: #000;
            .side-slip-item {
                flex-shrink: 0;
                width: px2rem(224);
                height: px2rem(126);
                margin-right: px2rem(4);
                background-size: cover;
                &:first-child {
                    margin-left: px2rem(0);
                }
            }
            .item-focus {
                border: px2rem(4) solid #38F;
                margin-right: 0;
                margin-left: px2rem(-4);
            }
        }
    }
</style>